import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { KeyboardShortcutDirective } from './directives/keyboard-shortcut.directive';
import { RestrictNumberDecimalsDirective } from './directives/restrict-number-decimals.directive';
import { ValueChangeHighlightDirective } from './directives/value-change-highlight.directive';
import { DialogService } from './dialog/dialog.service';
import { DialogYesNoComponent } from './dialog/dialog-yesno.component';
import { DialogStopAuctionComponent } from './dialog/dialog-stop-auction.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DemoMaterialModule } from '../demo-material-module';
import { ActionLoaderComponent } from './action-loader/action-loader.component';
import { AudioControlComponent } from './audio-control/audio-control.component';
import { UserAutocompleteComponent } from './components/user-autocomplete/user-autocomplete.component';
import { CardTemplateComponent } from './components/card-template/card-template.component';
import { DialogChangePwdComponent } from './dialog/dialog-changepwd.component';
import { DialogConnectedUsersComponent } from './dialog/dialog-connected-users.component';
import { DialogEnableUserRequestComponent } from './dialog/dialog-enable-user-request.component';
import { DialogNotificationComponent } from './dialog/dialog-notification.component';
import { DialogRememberPwdComponent } from './dialog/dialog-rememberpwd.component';
import { DialogSecurePhraseComponent } from './dialog/dialog-secure-phrase.component';
import { MenuItems } from './menu-items/menu-items';
import { DialogVideoComponent } from './videoplayer/dialog-video.component';
import { VideoPlayerService } from './videoplayer/videoplayer.service';
import { WarningActiveLotMessageComponent } from './messages/active-lot-warning.component';
import { AudioControlService } from './recording/audio-control-service';
import { WarningUserImportMessageComponent } from './messages/users-import-warning.component';
import { BooleanToTextPipe } from './pipes/text-boolean.pipe';
import { TranslationPipe } from './pipes/translation.pipe';
import { FirebaseDatePipe } from './pipes/fb-date.pipe';
import { DialogAssistedBidAssignComponent } from './dialog/dialog-assisted-bid-assign.component';
import { DialogCutBidRequestComponent } from './dialog/dialog-cut-bid-request.component';
import { PendingRequestsMessagePipe } from './dialog/pending-requests-message.pipe';
import { AuctionConnectedUsersComponent } from './components/auction-connected-users/auction-connected-users.component';
import { AuctionCutBidComponent } from './components/auction-cut-bid/auction-cut-bid.component';
import { AuctionEventInfoComponent } from './components/auction-event-info/auction-event-info.component';
import { AuctionRecentBidsComponent } from './components/auction-recent-bids/auction-recent-bids.component';
import { LotStatusTagComponent } from './components/lot-status-tag/lot-status-tag.component';
import { PageToolbarComponent } from './components/page-toolbar/page-toolbar.component';
import { LotService } from '../lots/lots.service';
import { VideoUrlDecodePipe } from './videoplayer/video-url.pipe';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { MultiMoneyPipe } from './pipes/multi-money.pipe';
import { ShowOnlyHoursPipe } from './pipes/show-only-hours.pipe';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { DigitOnlyModule } from '@uiowa/digit-only';

@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    DigitOnlyModule,
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    KeyboardShortcutDirective,
    RestrictNumberDecimalsDirective,
    ValueChangeHighlightDirective,
    DialogYesNoComponent,
    DialogStopAuctionComponent,
    DialogVideoComponent,
    WarningActiveLotMessageComponent,
    WarningUserImportMessageComponent,
    AudioControlComponent,
    DialogChangePwdComponent,
    DialogRememberPwdComponent,
    DialogSecurePhraseComponent,
    DialogEnableUserRequestComponent,
    DialogConnectedUsersComponent,
    DialogAssistedBidAssignComponent,
    DialogCutBidRequestComponent,
    PendingRequestsMessagePipe,
    PhoneInputComponent,
    CountryNamePipe,
    MultiMoneyPipe,
    ShowOnlyHoursPipe,
    DialogNotificationComponent,
    ActionLoaderComponent,
    BooleanToTextPipe,
    TranslationPipe,
    FirebaseDatePipe,
    AuctionConnectedUsersComponent,
    AuctionCutBidComponent,
    AuctionEventInfoComponent,
    AuctionRecentBidsComponent,
    CardTemplateComponent,
    LotStatusTagComponent,
    PageToolbarComponent,
    UserAutocompleteComponent,
    VideoUrlDecodePipe,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    KeyboardShortcutDirective,
    RestrictNumberDecimalsDirective,
    ValueChangeHighlightDirective,
    WarningActiveLotMessageComponent,
    WarningUserImportMessageComponent,
    AudioControlComponent,
    FormsModule,
    ReactiveFormsModule,
    ActionLoaderComponent,
    BooleanToTextPipe,
    FirebaseDatePipe,
    TranslationPipe,
    TranslateModule,
    AuctionConnectedUsersComponent,
    AuctionCutBidComponent,
    AuctionEventInfoComponent,
    AuctionRecentBidsComponent,
    CardTemplateComponent,
    LotStatusTagComponent,
    PageToolbarComponent,
    UserAutocompleteComponent,
    VideoUrlDecodePipe,
    PhoneInputComponent,
    CountryNamePipe,
    MultiMoneyPipe,
    ShowOnlyHoursPipe,
  ],
  providers: [AudioControlService, DialogService, LotService, MenuItems, VideoPlayerService],
  entryComponents: [
    DialogYesNoComponent,
    DialogStopAuctionComponent,
    DialogSecurePhraseComponent,
    DialogVideoComponent,
    DialogChangePwdComponent,
    DialogRememberPwdComponent,
    DialogEnableUserRequestComponent,
    DialogConnectedUsersComponent,
    DialogAssistedBidAssignComponent,
    DialogCutBidRequestComponent,
    DialogNotificationComponent,
  ],
})
export class SharedModule {}
